import React from "react";
import { useTranslation } from "react-i18next";
import styles from './messageSimplifiedHeader.module.scss';

const MessageSimplifiedHeader = () => {
  // translations
  const t = useTranslation("messages\\messages").t;

  return (
    <div className="d-none d-sm-block mb-2 text-muted font-weight-bold">
      <div className={`row no-gutters align-items-center px-3 ${styles.header}`}>
          <div className="col-sm-3 col-lg-2">
            {t("messageSimplifiedHeader.createdOn")}
          </div>
          <div className="col-sm-6 col-lg-5 text-truncate pr-sm-3 pl-sm-2">
            {t("messageSimplifiedHeader.title")}<span className="d-lg-none">/{t("messageSimplifiedHeader.messageCategoryName")}</span>
          </div>
          <div className="d-sm-none d-lg-block col col-lg-3">
            {t("messageSimplifiedHeader.messageCategoryName")}
          </div>
          <div className="col-sm-3 col-lg-2">
            {t("messageSimplifiedHeader.messageStatusName")}
          </div>
        </div>
    </div>
  );
};

export default MessageSimplifiedHeader;